// mock/data.js

export const MOCK_FILMS = [
  {
    id: 1,
    title: "L'Initié",
    director: "Samuel Codjovi",
    genre: "Aventure",
    year: 2025,
    duration: 120,
    synopsis: "Un danseur découvre ses racines spirituelles au Bénin.",
    poster: "/images/initie-poster.jpg",
    associatedProject: 101,
  },
  {
    id: 2,
    title: "Le Fétiche",
    director: "Benedicte Kouadio",
    genre: "Mystique",
    year: 2024,
    duration: 15,
    synopsis: "Un objet mystérieux bouleverse la vie d'un enfant.",
    poster: "/images/fetiche-poster.jpg",
    associatedProject: 102,
  },
];

export const MOCK_PROJECTS = [
  {
    id: 101,
    title: "L'Initié - Le Projet",
    director: "Samuel Codjovi",
    genre: "Aventure",
    goal: 10000000,
    raised: 4500000,
    endDate: "2025-05-31",
    synopsis: "Ce projet accompagne la réalisation du film L'Initié.",
    poster: "/images/initie-project.jpg",
    associatedFilm: 1,
  },
  {
    id: 102,
    title: "Le Fétiche - Le Projet",
    director: "Benedicte Kouadio",
    genre: "Mystique",
    goal: 3000000,
    raised: 1900000,
    endDate: "2025-04-20",
    synopsis: "Financer la postproduction et la diffusion de 'Le Fétiche'.",
    poster: "/images/fetiche-project.jpg",
    associatedFilm: 2,
  },
];
